export const getBSCornMasaFlourPackage = newProduct => {
  const newBSCornMasaFlourPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    Organic: newProduct.Organic,
  }
  return newBSCornMasaFlourPackage
}

export const updateBSCornMasaFlourPackage = newProduct => {
  const newBSCornMasaFlourPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
    Organic: newProduct.Organic,
  }
  return newBSCornMasaFlourPackage
}
